import { Box, Stack, Typography } from "@mui/material";

const IconAdsBudget = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12.5C0 5.59644 5.59644 0 12.5 0H47.5C54.4036 0 60 5.59644 60 12.5V47.5C60 54.4036 54.4036 60 47.5 60H12.5C5.59644 60 0 54.4036 0 47.5V12.5Z"
      fill="#FEF2F2"
    />
    <path
      d="M30 17.5V42.5"
      stroke="#E7000B"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.25 21.25H26.875C25.7147 21.25 24.6019 21.7109 23.7814 22.5314C22.9609 23.3519 22.5 24.4647 22.5 25.625C22.5 26.7853 22.9609 27.8981 23.7814 28.7186C24.6019 29.5391 25.7147 30 26.875 30H33.125C34.2853 30 35.3981 30.4609 36.2186 31.2814C37.0391 32.1019 37.5 33.2147 37.5 34.375C37.5 35.5353 37.0391 36.6481 36.2186 37.4686C35.3981 38.2891 34.2853 38.75 33.125 38.75H22.5"
      stroke="#E7000B"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconAdsTacos = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.21"
      d="M45 0C53.2843 0 60 6.71573 60 15V45C60 53.2843 53.2843 60 45 60H15C6.71573 60 0 53.2843 0 45V15C0 6.71573 6.71573 0 15 0H45Z"
      fill="#FEC53D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 16.5H21.75V19.5H17.25V16.5ZM17.25 24H21.75V27H17.25V24ZM21.75 31.5H17.25V34.5H21.75V31.5ZM24.75 16.5H44.25V19.5H24.75V16.5ZM44.25 24H24.75V27H44.25V24ZM24.75 31.5H27.75V34.5H24.75V31.5ZM21.75 39H17.25V42H21.75V39ZM27.75 39H24.75V42H27.75V39ZM36.9111 33.5215C36.4072 32.8008 35.6016 32.4404 34.4941 32.4404C33.4746 32.4404 32.707 32.7422 32.1914 33.3457C31.6758 33.9609 31.418 34.8222 31.418 35.9297C31.418 36.9785 31.6348 37.8076 32.0684 38.417C32.5723 39.1377 33.3779 39.498 34.4854 39.498C35.5049 39.498 36.2725 39.1933 36.7881 38.584C37.3037 37.9746 37.5615 37.1015 37.5615 35.9648C37.5615 34.9453 37.3447 34.1308 36.9111 33.5215ZM33.6768 34.4619C33.8701 34.1103 34.1426 33.9345 34.4941 33.9345C34.8457 33.9345 35.1152 34.1103 35.3027 34.4619C35.4902 34.8076 35.584 35.3086 35.584 35.9648C35.584 36.6269 35.4902 37.1338 35.3027 37.4853C35.1152 37.831 34.8457 38.0039 34.4941 38.0039C33.7617 38.0039 33.3955 37.3183 33.3955 35.9472C33.3955 35.3027 33.4893 34.8076 33.6768 34.4619ZM40.5234 32.2558L35.5752 45.29H37.3154L42.2637 32.2558H40.5234ZM45.7705 39.1289C45.2666 38.4082 44.4609 38.0478 43.3535 38.0478C42.334 38.0478 41.5664 38.3496 41.0508 38.9531C40.5352 39.5683 40.2773 40.4326 40.2773 41.5459C40.2773 42.5889 40.4941 43.4151 40.9277 44.0244C41.4316 44.7451 42.2373 45.1054 43.3447 45.1054C44.3643 45.1054 45.1318 44.8037 45.6475 44.2002C46.1631 43.5849 46.4209 42.709 46.4209 41.5722C46.4209 40.5527 46.2041 39.7383 45.7705 39.1289ZM42.5361 40.0605C42.7236 39.7148 42.9961 39.542 43.3535 39.542C44.0801 39.542 44.4434 40.2187 44.4434 41.5722C44.4434 42.9316 44.0801 43.6113 43.3535 43.6113C42.6211 43.6113 42.2549 42.9258 42.2549 41.5547C42.2549 40.9043 42.3486 40.4062 42.5361 40.0605Z"
      fill="#FEC53D"
    />
  </svg>
);

const IconAdsActive = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.21"
      d="M45 0C53.2843 0 60 6.71573 60 15V45C60 53.2843 53.2843 60 45 60H15C6.71573 60 0 53.2843 0 45V15C0 6.71573 6.71573 0 15 0H45Z"
      fill="#4AD991"
    />
    <g clipPath="url(#clip0_245_43444)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.375 16.5H44.625L45.75 17.625V30.0068C45.0533 29.4839 44.2983 29.0437 43.5 28.695V18.75H16.5V39H27.75C27.75 41.4342 28.5395 43.8027 30 45.75H21V43.5H27.75V41.25H15.375L14.25 40.125V17.625L15.375 16.5Z"
        fill="#4AD991"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0004 31.5173C34.9829 30.8534 36.0871 30.3902 37.2492 30.1544C38.4114 29.9185 39.6088 29.9147 40.7724 30.1431C41.9361 30.3715 43.0432 30.8276 44.03 31.4852C45.0168 32.1428 45.8639 32.989 46.5227 33.975C47.1815 34.9611 47.6389 36.0676 47.8686 37.231C48.0983 38.3944 48.0959 39.5918 47.8614 40.7542C47.6269 41.9167 47.165 43.0213 46.5022 44.0047C45.8394 44.9881 44.9889 45.8308 43.9994 46.4843C42.0145 47.7954 39.5913 48.2673 37.2595 47.7969C34.9277 47.3265 32.8769 45.9522 31.5555 43.9742C30.2341 41.9962 29.7495 39.5755 30.2076 37.2413C30.6657 34.907 32.0293 32.8491 34.0004 31.5173ZM38.7929 42.7448L44.1636 35.5853L42.3636 34.2353L37.6904 40.4656L34.7631 38.1233L33.3569 39.8783L37.1909 42.9473L38.7951 42.7448H38.7929Z"
        fill="#4AD991"
      />
    </g>
    <defs>
      <clipPath id="clip0_245_43444">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

const IconAdsRoas = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.21"
      d="M45 0C53.2843 0 60 6.71573 60 15V45C60 53.2843 53.2843 60 45 60H15C6.71573 60 0 53.2843 0 45V15C0 6.71573 6.71573 0 15 0H45Z"
      fill="#9810FA"
    />
    <path
      d="M37.9499 16.9496C37.9499 16.5916 38.0921 16.2482 38.3453 15.995C38.5985 15.7418 38.9418 15.5996 39.2999 15.5996H43.7999C44.1579 15.5996 44.5013 15.7418 44.7545 15.995C45.0077 16.2482 45.1499 16.5916 45.1499 16.9496V21.4496C45.1499 21.8077 45.0077 22.151 44.7545 22.4042C44.5013 22.6574 44.1579 22.7996 43.7999 22.7996C43.4418 22.7996 43.0985 22.6574 42.8453 22.4042C42.5921 22.151 42.4499 21.8077 42.4499 21.4496V20.2076L34.4039 28.2536C34.1508 28.5064 33.8076 28.6484 33.4499 28.6484C33.0921 28.6484 32.749 28.5064 32.4959 28.2536L28.0499 23.8076L20.4539 31.4036C20.3303 31.5362 20.1813 31.6426 20.0157 31.7164C19.8501 31.7902 19.6713 31.8299 19.49 31.8331C19.3088 31.8363 19.1287 31.8029 18.9606 31.735C18.7925 31.6671 18.6398 31.5661 18.5116 31.4379C18.3834 31.3097 18.2824 31.157 18.2145 30.9889C18.1466 30.8208 18.1132 30.6407 18.1164 30.4595C18.1196 30.2782 18.1593 30.0994 18.2331 29.9338C18.3069 29.7682 18.4132 29.6192 18.5459 29.4956L27.0959 20.9456C27.349 20.6928 27.6921 20.5508 28.0499 20.5508C28.4076 20.5508 28.7508 20.6928 29.0039 20.9456L33.4499 25.3916L40.5419 18.2996H39.2999C38.9418 18.2996 38.5985 18.1574 38.3453 17.9042C38.0921 17.651 37.9499 17.3077 37.9499 16.9496ZM19.4999 37.1996C19.8579 37.1996 20.2013 37.3418 20.4545 37.595C20.7077 37.8482 20.8499 38.1916 20.8499 38.5496V43.0496C20.8499 43.4077 20.7077 43.751 20.4545 44.0042C20.2013 44.2574 19.8579 44.3996 19.4999 44.3996C19.1418 44.3996 18.7985 44.2574 18.5453 44.0042C18.2921 43.751 18.1499 43.4077 18.1499 43.0496V38.5496C18.1499 38.1916 18.2921 37.8482 18.5453 37.595C18.7985 37.3418 19.1418 37.1996 19.4999 37.1996ZM28.0499 33.1496C28.0499 32.7916 27.9077 32.4482 27.6545 32.195C27.4013 31.9418 27.0579 31.7996 26.6999 31.7996C26.3418 31.7996 25.9985 31.9418 25.7453 32.195C25.4921 32.4482 25.3499 32.7916 25.3499 33.1496V43.0496C25.3499 43.4077 25.4921 43.751 25.7453 44.0042C25.9985 44.2574 26.3418 44.3996 26.6999 44.3996C27.0579 44.3996 27.4013 44.2574 27.6545 44.0042C27.9077 43.751 28.0499 43.4077 28.0499 43.0496V33.1496ZM33.8999 35.3996C34.2579 35.3996 34.6013 35.5418 34.8545 35.795C35.1077 36.0482 35.2499 36.3916 35.2499 36.7496V43.0496C35.2499 43.4077 35.1077 43.751 34.8545 44.0042C34.6013 44.2574 34.2579 44.3996 33.8999 44.3996C33.5418 44.3996 33.1985 44.2574 32.9453 44.0042C32.6921 43.751 32.5499 43.4077 32.5499 43.0496V36.7496C32.5499 36.3916 32.6921 36.0482 32.9453 35.795C33.1985 35.5418 33.5418 35.3996 33.8999 35.3996ZM42.4499 29.5496C42.4499 29.1916 42.3077 28.8482 42.0545 28.595C41.8013 28.3418 41.4579 28.1996 41.0999 28.1996C40.7418 28.1996 40.3985 28.3418 40.1453 28.595C39.8921 28.8482 39.7499 29.1916 39.7499 29.5496V43.0496C39.7499 43.4077 39.8921 43.751 40.1453 44.0042C40.3985 44.2574 40.7418 44.3996 41.0999 44.3996C41.4579 44.3996 41.8013 44.2574 42.0545 44.0042C42.3077 43.751 42.4499 43.4077 42.4499 43.0496V29.5496Z"
      fill="#9810FA"
    />
  </svg>
);

const getIcon = (type) => {
  switch (type) {
    case "active":
      return <IconAdsActive />;
    case "tacos":
      return <IconAdsTacos />;
    case "budget":
      return <IconAdsBudget />;
    case "roas":
      return <IconAdsRoas />;
    default:
      return null;
  }
};

export default function StatDescription({ iconType, description, maxWidth }) {
  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      sx={{ width: "100%" }}
    >
      {iconType && (
        <Box sx={{ width: "100%", height: "1005" }}>{getIcon(iconType)}</Box>
      )}

      <Typography
        sx={{
          maxWidth: maxWidth || "106px",
          color: "#464646",
          fontFamily: "Roboto",
          fontSize: "16px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
